import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FetchRoleForEditingService } from './fetch-role-for-editing.service';
import { GetSellerPermissionsService } from './get-seller-permissions.service';
import { CreatePermissionsService } from './create-permissions.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-add-role',
  templateUrl: './add-role.component.html',
  styleUrls: ['./add-role.component.scss']
})

export class AddRoleComponent implements OnInit {
  addRoleForm!: FormGroup;
  permissions: any[] = [];
  success = false;
  selectedRole: string = '';
  editMode = false;
  roleId = 0;
  roleObject: any;
  adminPermission = false;
  sellerPermission = false;
  constructor(
    private getPerms: GetSellerPermissionsService,
    private addPerms: CreatePermissionsService,
    private activatedRoute: ActivatedRoute,
    private fetchRole: FetchRoleForEditingService,
    private auth: AuthService,
    private router: Router,
    private snackBar: MatSnackBar,
    private fb: FormBuilder
  ) { }

  async ngOnInit() {
    this.adminPermission = await this.hasPermissionFor('Admin');
    this.sellerPermission = await this.hasPermissionFor('Seller');
    if (this.activatedRoute.snapshot.params.id) {
      this.editMode = true;
      this.roleId = this.activatedRoute.snapshot.params.id;
      this.fetchRole.setParams({
        id: this.roleId
      });
      const result = await this.fetchRole.make();
      this.roleObject = result;
      console.log(result);
    }
    /* Role Name is required.
    Role Type is required.
    Role Permission is required.
    */
    this.addRoleForm = this.fb.group({
        roleName: ['', Validators.required],
        userType: ['', Validators.required],
        permissions: ['', Validators.required],
        temp:[false],
    });

    if (this.editMode && this.roleObject) {
      // this.editMode = false;
      this.addRoleForm.controls['roleName'].setValue(this.roleObject.name);
      this.addRoleForm.controls['userType'].setValue(this.roleObject.type);
      this.addRoleForm.controls['temp'].setValue(this.roleObject.temp);
      const r = await this.typeChanged(this.roleObject.type);
      setTimeout(() => {
        let permissions = this.roleObject.Permissions.filter((i: any) => i.assignable);
        permissions = permissions.map((i: any) => i.id);
        this.addRoleForm.controls['permissions'].setValue(permissions);
      }, 100);
    }

  }

  async onSubmit() {
    try {
      const isTemp=this.addRoleForm.value.userType =='Admin' ? false:this.addRoleForm.value.temp;
      this.addPerms.setParams({
        name: this.addRoleForm.value.roleName,
        type: this.addRoleForm.value.userType,
        permissions: this.addRoleForm.value.permissions,
        temp:isTemp,
        id: this.roleId,
        uniqueCurrentId: this.roleId
      });
      const res = await this.addPerms.make();
      if (res.status === 'success') {
        this.snackBar.open(`Role ${this.editMode ? 'Edited' : 'Added'} Successfully!`, '', {
          duration: 3000
        });
        this.router.navigate(['/admin/actions/roles/manage']);
      }
    } catch (err) {
      if (err.validationErrors) {
        const e = err.validationErrors.error;
        this.addRoleForm.controls['roleName'].setErrors({
          incorrect: e[0].message
        });
      }
    }
  }

  async hasPermissionFor(roleType: string) {
    const permissions = await this.auth.getPermissions();
    for (const perm of permissions) {
      const action = perm.action;
      if (action === `Admin.add${roleType}Role`) {
        return true;
      }
    }
    return false;
  }

  async typeChanged(event: any) {
    this.selectedRole = event;
    if (this.selectedRole === 'Admin') {
      let perms = await this.auth.getPermissions();
      perms = perms.filter((perm: any) => perm.assignable);
      this.permissions = perms;
    } else {
      try {
        this.getPerms.setParams({ by: 'Seller' });
        const res = await this.getPerms.make();
        this.permissions = res;
      } catch (err) {
        console.log(err);
      }
    }
  }
}
